<template lang="pug">
  div
    //.d-flex.align-items-center.justify-content-center(style="color: #fff; background: #000; padding: 10px; width: 100%; font-size: 1.2rem; height: 50px; font-weight: bold;") Event預約
    .container.position-relative
      .d-flex.no-gutters
        .col-10.multiselect_custom_storeReservationList.p-3
          multiselect(
            placeholder="請選擇預約主題",
            :options="activityDropdown",
            :searchable="false",
            :allow-empty="false",
            label="name",
            tracy-by="activity_reserve_store_id"
            v-model="nowSelectActivity",
            selectLabel='',
            deselect-label='',
            @input='resetData',
            noOptions="無預約主題"
          )
            template(slot="noOptions")
              strong 無預約主題
          b-collapse#collapse-searchBody(
            block
          )
            .multiselect_custom_storeReservationList.mt-2(v-if="profile" v-show='profile.stores.length > 1')
              multiselect(
                placeholder="請選擇店舖",
                :options="profile.stores",
                :searchable="false",
                :allow-empty="false",
                label="title",
                tracy-by="id"
                v-model="nowSelectStore",
                selectLabel='',
                deselect-label='',
              )
            .multiselect_custom_storeReservationList.mt-2
              multiselect(
                placeholder="請選擇預約狀態",
                :options="reservationStatusList",
                :searchable="false",
                :allow-empty="false",
                label="name",
                track-by="value",
                v-model="nowSelectStatus",
                selectLabel='',
                deselect-label='',
                @input='resetData'
              )
            .multiselect_custom_storeReservationList.mt-2
              multiselect(
                placeholder="請選擇預約月份",
                :options="monthOptions",
                :searchable="false",
                :allow-empty="false",
                label="name"
                v-model="nowSelectMonth",
                selectLabel='',
                deselect-label='',
                @input='resetData'
              )
            b-input-group.mt-2
              b-form-input(
                v-model="name"
                placeholder="請輸入預約姓名或預約手機號碼"
                style='background-color: #000; color: #FFF; border: 1px solid #AAA; border-radius: 0;'
              )
            b-input-group.d-flex.mt-2
              .col-6
                button.btn.btn-block.p-0(@click="reset()" style="color: #FFF; border: solid 1px #aaa; height: calc(1.5em + 0.75rem + 2px); font-size: 14px") 重置
              .col-6
                button.btn.btn-block.p-0(@click="resetData()" style="color: #FFF; border: solid 1px #aaa; height: calc(1.5em + 0.75rem + 2px); font-size: 14px") 搜尋
        .col-2.pl-2
          b-button(
            style='background-color: #000'
            block,
            v-b-toggle.collapse-searchBody
          )
            i.fas.fa-align-justify.d-flex.align-items-center.justify-content-center.text-white
      div(style="margin-top: 20px;")(v-if="nowSelectActivity") {{ nowSelectActivity.name }}  共
        span(v-if="eventActivityMemberList") {{ pagination.total }} 筆
        span(v-else) 0 筆
      .resultList
        .resultItem(v-for="(member, index) in eventActivityMemberList")
          .d-flex.align-items-center.justify-content-center
            div(style="width: 70px; border-radius: 50%; border: solid 1px #aaa;")
              img(:src="member.member.picture_url" style="width: 100%; height: auto; border-radius: 50%;")
            div(style="margin-left: 20px; text-align: left;")
              div 姓名： {{ member.member.chinese_first_name ? member.member.chinese_first_name : '' }} {{ member.member.chinese_last_name ? member.member.chinese_last_name : '' }}
              div 暱稱名： {{ member.member.display_name }}
          div.py-2.m-0(style="width: 100%; color: #fff; background: #000; justify-content: space-around; flex-wrap: wrap;")
            div.mx-2.my-1 預約姓名： {{ member.meta.name }}
            div.mx-2.my-1 預約手機： {{ member.meta.mobile }}
          div
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-calendar-check
              span(style="margin-left: 10px; white-space: nowrap") 預約時間：
              .d-flex.align-items-center.flex-wrap
                span.mr-2.my-0(style="white-space: nowrap") {{ moment(member.reserve_start_at).format('YYYY-MM-DD') }}
                span.mr-2.my-0 {{ moment(member.reserve_start_at).format('HH:mm') }} - {{ moment(member.reserve_end_at).format('HH:mm') }}
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-user
              span(style="margin-left: 10px;") 服務顧問： {{ member.personnel.chinese_last_name ? member.personnel.chinese_last_name : '' }} {{ member.personnel.chinese_first_name ? member.personnel.chinese_first_name : '' }}
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-calendar-alt
              span(style="margin-left: 10px;") 預約狀態： {{ filterStatus(member.status) }}
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-credit-card
              span(style="margin-left: 10px;") 付款狀態： {{ filterPayStatus(event.pay_status) }}
          .d-flex.align-items-center.mt-2(v-if="member.status === 2" style="flex-wrap: wrap; justify-content: space-between")
            button.btn.btn-dark(type="button", @click="cancel(member.id, index)", style="width: 30%;")
              span 取消預約
            button.btn.btn-dark(type="button", @click="editHandler(member)", style="width: 30%;")
              span 修改預約
            button.btn.btn-dark(type="button", @click="successHandler(member.id, index)", style="width: 30%;")
              span 出席

        //.resultItem(v-for="searchItem in searchResult")
          .d-flex.align-items-center.justify-content-center
            div(style="width: 70px; border-radius: 50%; border: solid 1px #aaa;")
              img(:src="searchItem.profile.img" style="width: 100%; height: auto; border-radius: 50%;")
            div(style="margin-left: 20px; text-align: left;")
              div 姓名： {{ searchItem.profile.name }}
              div 暱稱名： {{ searchItem.profile.nick }}
          .d-flex.align-items-center(style="width: 100%; color: #fff; background: #000; padding: 0 10px; justify-content: space-around; flex-wrap: wrap;")
            div 預約姓名： {{ searchItem.profile.name }}
            div 預約手機： {{ searchItem.userPhone }}
          div
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-calendar-check
              span(style="margin-left: 10px;") 預約時間： {{ searchItem.timeRange }}
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-user
              span(style="margin-left: 10px;") 服務顧問： {{ searchItem.consultant }}
            .d-flex.align-items-center(style="margin: 5px 0;")
              div(style="width: 20px; margin: 0;")
                i.fas.fa-credit-card
              span(style="margin-left: 10px;") 付款狀態： {{ PayTypeList[searchItem.payStatus] }}
          .d-flex.align-items-center.justify-content-center.mt-2(style="flex-wrap: wrap;")
            button.btn.btn-dark(type="button", @click="", style="width: 30%; min-width: 100px; margin: 5px;")
              span 取消預約
            button.btn.btn-dark(type="button", @click="", style="width: 30%; min-width: 100px; margin: 5px;")
              span 修改預約
            button.btn.btn-dark(type="button", @click="", style="width: calc(60% + 10px); min-width: 210px; margin: 5px;")
              span 出席
      infinite-loading(
        v-if="nowSelectActivity"
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料，
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次

      span(v-else) 當前無選擇預約主題
</template>

<script>
  import { mapState } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import { SA_EVENT_ACTIVITY_EDIT } from '../../../router/sa/event-activity';

  const moment = require('moment');

  export default {
    // 不管這邊打大小寫 顯示都會是以大寫形式為主
    name: 'event-activity-list',
    components: {
      InfiniteLoading
    },
    data() {
      return {
        reservationThemeList: ['產品諮詢', '美容保養'],
        reservationStatusList: [
          {
            value: 2,
            name: '完成預約'
          },
          {
            value: 3,
            name: '出席'
          },
          {
            value: 4,
            name: '未出席'
          },
          {
            value: 5,
            name: '取消預約'
          }
        ],
        reservationTheme: '',
        reservationStatus: '',
        searchResult: [],
        nowSelectActivity: null,
        nowSelectStatus: null,
        nowSelectMonth: null,
        nowSelectStore: null,
        monthOptions: [],
        infiniteId: +new Date(),
        name: null,
        mobile: null,
      };
    },
    methods: {
      infiniteHandler($state) {
        const vm = this;
        if (!vm.nowSelectActivity) return;
        // 當前頁數 + 分頁比數 + 選擇的活動 + 選擇的狀態 + 選擇的月份
        const query = `${vm.name ? `keyword=${vm.name}&` : ''}${vm.mobile ? `mobile=${vm.mobile}&` : ''}current_page=${vm.pagination.current_page + 1}&per_page=${vm.pagination.per_page}${vm.nowSelectActivity ? `&activity_reserve_id=${vm.nowSelectActivity.id}` : ''}${vm.nowSelectStatus ? `&status=${vm.nowSelectStatus.value}` : ''}${vm.nowSelectMonth ? `&${vm.nowSelectMonth.value}` : ''}`;
        vm.$store.dispatch('sa_event_activity/getEventActivityMemberListHandler', query).then(() => {
          if (vm.pagination.current_page !== vm.pagination.total_page) {
            $state.loaded();
          } else {
            $state.complete();
          }
          $state.complete();
        }).catch(() => {
          $state.complete();
        });
      },
      moment(time) {
        return moment(time);
      },
      resetData() {
        const vm = this;
        vm.$store.commit('sa_event_activity/resetEventActivityMemberList');
        vm.infiniteId += 1;
      },
      filterStatus(val) {
        switch (val) {
          case 2:
            return '完成預約';
          case 3:
            return '出席';
          case 4:
            return '未出席';
          case 5:
            return '取消預約';
          default:
            return '';
        }
      },
      filterPayStatus(val) {
        switch (val) {
          case 0:
            return '待付款';
          case 1:
            return '已付款';
          case 2:
            return '繳款失敗';
          case 3:
            return '取消授權';
          case 4:
            return '取消授權失敗';
          default:
            return '';
        }
      },
      cancel(id, index) {
        const vm = this;
        vm.$store.dispatch('sa_event_activity/cancelEventActivityHandler', id).then(() => {
          vm.$snotify.success(null, '取消預約成功');
          if (vm.nowSelectStatus !== null) {
            vm.$store.commit('sa_event_activity/removeEventActivity', index);
          } else {
            vm.$store.commit('sa_event_activity/updateEventActivity', { index, status: 5 });
          }
        });
      },
      editHandler(member) {
        const vm = this;
        vm.$router.push({
          name: SA_EVENT_ACTIVITY_EDIT,
          params: {
            id: member.id,
          }
        });
      },
      reset() {
        const vm = this;
        vm.nowSelectStatus = null;
        vm.nowSelectMonth = vm.monthOptions[0];
        vm.resetData();
      },
      successHandler(id, index) {
        const vm = this;
        vm.$store.dispatch('sa_event_activity/cancelEventActivityHandler', id).then(() => {
          vm.$snotify.success(null, '出席成功');
          if (vm.nowSelectStatus !== null) {
            vm.$store.commit('sa_event_activity/removeEventActivity', index);
          } else {
            vm.$store.commit('sa_event_activity/updateEventActivity', { index, status: 3 });
          }
        });
      }
    },
    mounted() {
      const vm = this;
      vm.$store.commit('sa_event_activity/resetEventActivityMemberList');
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_profile/getProfileHandler').then((res) => {
        vm.nowSelectStore = vm.profile.stores[0];
        vm.$store.dispatch('sa_event_activity/getActivityDropdownHandler', vm.nowSelectStore.id).then(() => {
          if (vm.activityDropdown.length > 0) {
            vm.nowSelectActivity = vm.activityDropdown[0];
          }
          vm.$swal.close();
        });
      });
      vm.monthOptions = [];
      let i = 0;
      for (i = 0; i < 12; i++) {
        const month = moment(new Date()).subtract(i, 'months');
        const monthStart = moment(new Date()).subtract(i, 'months').startOf('month').format('YYYY-MM-DD');
        const monthEnd = moment(new Date()).subtract(i, 'months').endOf('month').format('YYYY-MM-DD');

        vm.monthOptions.push(
          {
            name: `${month.month() + 1}月`,
            value: `reserve_start_at=${monthStart}&reserve_end_at=${monthEnd}`
          }
        );
        if (i === 0) {
          vm.nowSelectMonth = {
            name: `${month.month() + 1}月`,
            value: `reserve_start_at=${monthStart}&reserve_end_at=${monthEnd}`
          };
        }
      }
      vm.$store.commit('toggleLoading', false);
    },
    watch: {
      reservationStatus() {
        //  假的 現在都是假的
        window.setTimeout(() => {

        }, 800);
      }
    },
    computed: {
      ...mapState({
        activityDropdown: (state) => state.sa_event_activity.activityDropdown,
        pagination: (state) => state.sa_event_activity.pagination,
        profile: (state) => state.sa_profile.data,
        eventActivityMemberList: (state) => state.sa_event_activity.eventActivityMemberList
      })
    }
  };
</script>
<style scoped lang="scss">
  .container {
    padding: 20px;
  }

  .resultList {
    margin: 20px 0;
    .resultItem {
      text-align: left;
      margin: 10px 0;
      background: #eee;
      padding: 10px 20px;
      & div {
        margin: 10px 0;
      }
    }
  }
</style>
<style  lang="scss">
  .multiselect_custom_storeReservationList {
    background: #000;
    & .multiselect__tags {
      border: solid 1px #aaa;
      background: #000;
      border-radius: 0;
    }
    & .multiselect__input,
    & .multiselect__single {
      background: #000;
      color: #fff;
    }
    & .multiselect__placeholder {
      background: #000;
      color: #fff;
    }
  }
</style>
<style lang='scss' scoped>
  .searchArea {
    &__iconArrow {
      position: absolute;
      right: 10px;
      top: 5px;
      outline: none;
      transform: rotate(0deg);
      transition: all .3s;
    }
    &__iconArrow.collapsed {
      transform: rotate(180deg);
    }
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #FFF;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #FFF;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: #FFF;
  }
</style>
